<script lang="ts">
    import {Utils} from "../util";
    import type {Property} from "../models/model";
    import type {Answer} from "../models/model";
    import {ASSET_URL, translations} from "../config";
    import {_} from '../services/i18n';

    export let data: Answer[] = [];
    export let hasPact: any = false;
    export let showPactInfo: boolean = true;
    export let properties: Property[] = [];
    export let hideUI = false;
    export let mapType: string = "";



    export let excludeQuestionIds: number[]|null = null;
    export let includeQuestionIds: number[]|null = null;

    /** Cast to answer */
    function a(a: any): Answer {
        return a;
    }

    /*
    function getProperty(id: number): Property {
        return properties.find(item => item.id == id);
    }

     */

    $: answersWithPropertiesRaw = data.map(answer => {
        const p = properties.find(item => item.id == answer.property_id);

        return {...answer, property: p};
    }).filter(answer => {
        const id = answer.property_id;
        if (excludeQuestionIds !== null && includeQuestionIds !== null) {
            // Merge: Included OR Not Excluded
            return includeQuestionIds.includes(id) || !excludeQuestionIds.includes(id);
        } else if (includeQuestionIds !== null) {
            // Only included
            return includeQuestionIds.includes(id);
        } else if (excludeQuestionIds !== null) {
            // All except excluded
            return !excludeQuestionIds.includes(id);
        }
        // Default: show all
        return true;
    }) || [];

    $: answersWithProperties = answersWithPropertiesRaw;


</script>

<div id="questions" class="answer-wrapper" hidden={data?.length > 0 ? '' : 'none'}>


    {#if  showPactInfo}
        <div class="answer-item">
            <label>
                {$_('legend.pact')}
            </label>
            {#if hasPact}
                <span><img src="{ASSET_URL}/assets/img/icons/mfi-status-yes.svg"></span>
            {:else}
                <span><img src="{ASSET_URL}/assets/img/icons/mfi-status-no.svg"></span>
            {/if}
        </div>
    {/if}

    {#each answersWithProperties as answer}
        <div class="answer-item">
            {#if answer?.property?.hasDropdown}
                <label>
                    {#if answer?.property?.hasUrl && (answer.inputValue === 'yes' || answer.value === true) }
                        <a target="_blank" href="{answer.url}" style="display:inline-flex; gap:0.5rem;">{Utils.chooseTranslation(answer.property.name)}
                            <img src="{ASSET_URL}/assets/img/icons/link.svg">
                        </a>
                    {:else}
                        {Utils.chooseTranslation(answer.property.name)}
                    {/if}
                </label>
                <span>
                    <img src="{ASSET_URL}/assets/img/icons/mfi-status-{answer.inputValue}.svg">
                </span>
            {:else if answer.text}
                <label>{Utils.chooseTranslation(answer.property.name)}</label>
                <span>{answer.text}</span>
            {:else if answer.property.hasInput}
                <!--todo check for percentage in next updates, api should put this in the response -->


                <label>{Utils.chooseTranslation(answer.property.name)}</label>
                <span style="font-weight:700">
                    {answer?.inputValue}%
                </span>
            {:else}
                <label>
                    {#if answer.property.hasUrl && answer?.value === true }
                        <a target="_blank" href="{answer?.url}">{Utils.chooseTranslation(answer.property.name)}
                            <img src="{ASSET_URL}/assets/img/icons/link.svg">
                        </a>
                    {:else}
                      {Utils.chooseTranslation(answer.property.name)}
                    {/if}
                </label>
                {#if answer?.value}
                    <span><img src="{ASSET_URL}/assets/img/icons/mfi-status-yes.svg"></span>
                {:else}
                    <span><img src="{ASSET_URL}/assets/img/icons/mfi-status-no.svg"></span>
                {/if}
            {/if}
        </div>

    {/each}

</div>

<style lang="scss">


    .answer-wrapper {

        display: flex;
        flex-direction: column;
        //row-gap:20px;

        & * {

            margin-bottom: 0;
        }

        .answer-item {

            display: flex;
            justify-content: space-between;
            border-bottom: 2px dashed #F8F7F7;
            column-gap: 20px;
            align-items: center;
            padding-top: 10px;
            padding-bottom: 10px;

            span {
                align-items: center;
                display: flex;
            }

            label a {
                color: #000000;
                text-decoration: underline;

                img {
                    padding-bottom: 5px;
                }

            }

        }

    }


</style>

